module.exports = __webpack_public_path__ + "img/004.4c146a4f.png";